import React, { useState } from 'react';
import "../styles/second-menu.css";
import { Link } from 'react-router-dom';

const SecondMenu = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <div className="menu-wrapper">
      <div className="hamburger-menu" onClick={toggleNav}>
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
      </div>
      <div className="main">
        <div className={`slide-nav ${isNavOpen ? 'open' : ''}`} id="slideNav">
          <span className="close-btn" onClick={toggleNav}>
            <i className="fa-solid fa-xmark" />
          </span>
          {/* Your navigation links */}
          <Link to={"/anti-ragging"}>Anti Ragging</Link>
          <Link to={"https://mail.google.com/"}>CCSU E-mail</Link>
          <Link to={"/downloads"}>Downloads</Link>
          <Link to={"/enquiry-numbers"}>Enquiry Numbers</Link>
          <Link to={"/imp-email"}>Important E-mail</Link>
          <Link to={"/tenders"}>Tenders</Link>
          <Link to={"/dept-sports"}>Sports</Link>
          <Link to={"/career"}>Employment/Vacancies</Link>
          <Link to={"/nirf"}>NIRF</Link>
          <Link to={"https://education-policy.ccsuniversity.ac.in/"} target="_blank" rel="noopener noreferrer">NEP-2020</Link>
          <Link to={"/infra"}>Infrastructure</Link>
          <Link to={"/admission-brochure"}>Brochure Download</Link>
          <Link to={"/syllabus"}>Syllabus</Link>
          <Link to={"/admission"}>Admission</Link>
          <Link to={"/contact"}>Contact Us</Link>
          <Link to={"/gallery"}>Gallery</Link>
          <Link to={"/mobile-app"}>CCSU, Mobile App</Link>
          <Link to={"/convocation"}>36th Convocation-2024</Link>
          <Link to={"https://scriet.ccsuniversity.ac.in"} target="_blank" rel="noopener noreferrer">Institute of Engineering &amp; Technology</Link>
          <Link to={"https://gccjr.org/"} target="_blank" rel="noopener noreferrer">Shanti Devi Government College (Constituent College)</Link>
        </div>
        <div id="main-nav-bar" className={isNavOpen ? 'visible' : ''} onClick={toggleNav}></div>
      </div>
    </div>
  );
};

export default SecondMenu;
